module.exports = __webpack_public_path__ + "static/media/logo_default.03eb3796.png";


//////////////////
// WEBPACK FOOTER
// ./src/statics/images/logo_default.png
// module id = ./src/statics/images/logo_default.png
// module chunks = 0